import React from 'react';
import { createFileRoute } from '@tanstack/react-router';
import { motion } from 'framer-motion';
import { LandingPageHero } from '@/routes/_layout/-components/landing-page-hero';
import { WhatIsAdora } from '@/routes/_layout/-components/what-is-adora';
import { HowItWorks } from '@/routes/_layout/-components/how-it-works';
import { FeedbackSpotlight } from '@/routes/_layout/-components/feedback-spotlight';
import { Pricing } from '@/routes/_layout/-components/pricing';
import { CampaignModesSpotlight } from '@/components/campaign-modes-spotlight';
import { container } from '@/constants/motion';
export const Route = createFileRoute('/_layout/')({
    component: HomePage,
    head: () => ({
        meta: [
            { title: 'Adora Analytics – Smart Links for QR & Post Performance Tracking' },
            {
                name: 'description',
                content: 'Adora turns QR codes, flyers, and shared links into measurable campaigns. See where your customers come from and what they want—without guesswork.',
            },
            { property: 'og:title', content: 'Adora Analytics – Smart Links for QR & Post Performance Tracking' },
            {
                property: 'og:description',
                content: 'Adora turns QR codes, flyers, and shared links into measurable campaigns. See where your customers come from and what they want—without guesswork.',
            },
        ],
    }),
});
function HomePage() {
    return (<motion.main initial="hidden" animate="visible" variants={container}>
            {/* HERO */}
            <LandingPageHero />

            {/* WHAT IS ADORA */}
            <WhatIsAdora />

            {/* HOW IT WORKS */}
            <HowItWorks />

            {/* CAMPAIGN MODES — showroom / auto-store / custom theme */}
            <CampaignModesSpotlight />

            {/* FEEDBACK CAMPAIGNS — feature spotlight */}
            <FeedbackSpotlight />

            {/* QUICK FEATURE PREVIEW + PRICING TEASER */}
            <Pricing />
        </motion.main>);
}
